import { render, staticRenderFns } from "./addMain.vue?vue&type=template&id=5ae595f2"
import script from "./addMain.vue?vue&type=script&lang=js"
export * from "./addMain.vue?vue&type=script&lang=js"
import style0 from "./addMain.vue?vue&type=style&index=0&id=5ae595f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports